import { Expose } from 'class-transformer';
import { IsDate, IsEnum, IsNumber, IsString } from 'class-validator';
import { AcceptanceTermsType } from './acceptance-term-type';

export class AcceptanceTerm {
  @IsString()
  readonly id: string;

  @IsEnum(AcceptanceTermsType)
  @Expose({ name: 'term_type' })
  readonly type: AcceptanceTermsType;

  @IsString()
  readonly url: string;

  @IsNumber()
  readonly version: number;

  @IsDate()
  @Expose({ name: 'created_at' })
  readonly createdAt: Date;

  constructor(init?: AcceptanceTerm | Partial<AcceptanceTerm>) {
    this.id = init?.id!;
    this.type = init?.type!;
    this.url = init?.url!;
    this.version = init?.version!;
    this.createdAt = init?.createdAt!;
  }
}

export default AcceptanceTerm;
